import { useAppSelector } from '@app/hooks';
import Loader from './Loader';

const AppLoader: React.FC = () => {
  const { isLoading } = useAppSelector((state) => state.auth);
  return <Loader isLoading={isLoading} />;
};

export default AppLoader;
